
import mapboxgl from 'mapbox-gl';

export function createCircle(item) {
    const total = item.projects.length;
    const fontSize = total >= 10 ? 20 : total >= 5 ? 18 : total >= 2 ? 16 : 14;
    // const r = total >= 10 ? 50 : total >= 5 ? 32 : total >= 2 ? 24 : 18;
    const r = 14 + total*2;
    const w = r * 2;
    let html = `<div class="circle-marker" style="cursor:pointer;width:${w}px;height:${w}px;" data-title="${item.name}">
        <span>${total.toLocaleString()}</span>
    </div>`;

    const el = document.createElement('div');
    el.innerHTML = html;
    return el.firstChild;
}


export function drawMarkers(map, data, clickHandler) {

    const markers = [];
    data.forEach(item => {
        const el = createCircle(item);
        el.dataset.city_id = item.id;
        el.addEventListener('click', clickHandler);
        // el.title = item.name;
        const marker = new mapboxgl.Marker({
            element: el
        }).setLngLat([item.lng, item.lat]);
        marker.addTo(map);
        markers.push(marker);
    });
    fitBounds(map, markers);
    return markers;
}


export function fitBounds(map, markers)
{
    if (!markers.length) return;
    const bounds = new mapboxgl.LngLatBounds(
        markers[0].getLngLat(),
        markers[0].getLngLat()
    );
    markers.forEach(m => bounds.extend(m.getLngLat()));
    map.fitBounds(bounds, {padding: {top: 200, bottom: 200, left: 200, right: 200}});
}

export function loadIcons(map, icons) {
    const icon_promises = icons.map(icon => new Promise((resolve, reject) => {
        map.loadImage(`/img/${icon}.png`, (error, image) => {
                if (error){
                    console.error(`Icon "${icon}" not found: ${error}`);
                    resolve([icon, null]);
                } else {
                    map.addImage(icon, image);
                    resolve([icon, image]);
                }
            });
        })
    );
    return Promise.all(icon_promises);
}

